import CONST_AUTH from 'constants/auth';
import CONST_PROFILE from 'constants/profile';

const ERROR_CODE_MAP = new Map([
  // ADDRESS SERVICE
  [
    'genericrepository.repository.user.validation.notunique',
    {
      message: 'Dados cadastrais já utilizados',
    },
  ],
  [
    'companyservice.auth.invalidcnpj',
    {
      message: 'CNPJ não encontrado',
    },
  ],
  [
    'auth/user-not-found',
    {
      message: 'Usuário não encontrado',
    },
  ],
  [
    'auth/wrong-password',
    {
      message: 'Senha inválida',
    },
  ],
  [
    'auth/invalid-email',
    {
      message: 'Email inválido'
    }
  ],
  [
    'Timeout: Request failed to complete in 120000ms',
    {
      message: 'Tempo de operação esgotado',
    }
  ],
  [
    'companyservice.auth.invalidpassword',
    {
      message: 'Senha incorreta',
    },
  ],
  [
    'userdocument.document.invalid',
    {
      message: 'Favor informar o campo documento corretamente',
    },
  ],
  [
    'addressservice.validation.addressid',
    {
      message: 'Favor informar o campo addressid do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.companyid',
    {
      message: 'Favor informar o campo companyid do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.userid',
    {
      message: 'Favor informar o campo userid do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.schoolid',
    {
      message: 'Favor informar o campo schoolid do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.cep',
    {
      message: 'Favor informar o campo cep do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.street',
    {
      message: 'Favor informar o campo rua do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.number',
    {
      message: 'Favor informar o campo número do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.compl',
    {
      message: 'Favor informar o campo complemento do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.neigh',
    {
      message: 'Favor informar o campo bairro do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.city',
    {
      message: 'Favor informar o campo cidade do endereço corretamente',
    },
  ],
  [
    'addressservice.validation.state',
    {
      message: 'Favor informar o campo Estado do endereço corretamente',
    },
  ],
  [
    'addressservice.create.generic',
    {
      message: 'Erro ao cadastrar o endereço',
    },
  ],
  [
    'addressservice.update.generic',
    {
      message: 'Erro ao atualizar o endereço',
    },
  ],
  [
    'addressservice.remove.generic',
    {
      message: 'Erro ao deletar o endereço',
    },
  ],
  [
    'addressservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // APP USER SERVICE
  [
    'appuserservice.validation.id',
    {
      message: 'Favor informar o campo id do usuário corretamente',
    },
  ],
  [
    'appuserservice.validation.name',
    {
      message: 'Favor informar o campo nome do usuário corretamente',
    },
  ],
  [
    'appuserservice.validation.email',
    {
      message: 'Favor informar o campo email do usuário corretamente',
    },
  ],
  [
    'appuserservice.validation.phone',
    {
      message: 'Favor informar o campo telefone do usuário corretamente',
    },
  ],
  [
    'appuserservice.validation.document',
    {
      message: 'Favor informar o campo documento do usuário corretamente',
    },
  ],
  [
    'appuserservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do usuário corretamente',
    },
  ],
  [
    'appuserservice.validation.uid',
    {
      message: 'Favor informar o campo uid do usuário corretamente',
    },
  ],
  [
    'appuserservice.validation.users',
    {
      message: 'Favor informar o campo users do usuário corretamente',
    },
  ],
  [
    'appuserservice.validation.token',
    {
      message: 'Favor informar o campo token do usuário corretamente',
    },
  ],
  [
    'appuserservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],
  [
    'appuserservice.listappuser.notfound',
    {
      message: 'Erro ao encontrar usuário',
    },
  ],
  [
    'appuserservice.addcreditrequest.generic',
    {
      message: 'Erro ao gerar pedido de crédito',
    },
  ],
  [
    'appuserservice.create.generic',
    {
      message: 'Erro ao cadastrar o usuário',
    },
  ],
  [
    'appuserservice.update.generic',
    {
      message: 'Erro ao atualizar o usuário',
    },
  ],
  [
    'appuserservice.remove.generic',
    {
      message: 'Erro ao deletar o usuário',
    },
  ],
  [
    'appuserservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // USER SERVICE
  [
    'user.error.document.used',
    {
      message: 'O documento já está em uso',
    },
  ],
  [
    'user.error.document.invalid',
    {
      message: 'Favor informar o campo documento corretamente',
    },
  ],
  [
    'user.error.phone.invalid',
    {
      message: 'Favor informar o campo telefone corretamente',
    },
  ],
  [
    'Validation error: user.error.phone.invalid',
    {
      message: 'Favor informar o campo telefone corretamente',
    },
  ],
  [
    'user.error.email.used',
    {
      message: 'O email já está em uso',
    },
  ],

  // BUG REPORTS SERVICE
  [
    'bugreportservice.validation.bugreportid',
    {
      message: 'Favor informar o campo bugreportid do erro corretamente',
    },
  ],
  [
    'bugreportservice.validation.title',
    {
      message: 'Favor informar o campo título do erro corretamente',
    },
  ],
  [
    'bugreportservice.validation.description',
    {
      message: 'Favor informar o campo descrição do erro corretamente',
    },
  ],
  [
    'bugreportservice.validation.version',
    {
      message: 'Favor informar o campo versão do erro corretamente',
    },
  ],
  [
    'bugreportservice.validation.fixcomment',
    {
      message:
        'Favor informar o campo comentário de correção do erro corretamente',
    },
  ],
  [
    'bugreportservice.validation.fixversion',
    {
      message: 'Favor informar o campo versão corrigida do erro corretamente',
    },
  ],
  [
    'bugreportservice.validation.uid',
    {
      message: 'Favor informar o campo uid do erro corretamente',
    },
  ],
  [
    'bugreportservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do erro corretamente',
    },
  ],
  [
    'bugreportservice.validation.picture',
    {
      message: 'Favor insira uma extensão de imagem suportada',
    },
  ],
  [
    'bugreportservice.validation.photourl',
    {
      message: 'Favor insira uma extensão de imagem suportada',
    },
  ],
  [
    'bugreportservice.validation.status',
    {
      message: 'Favor informar o campo status do erro corretamente',
    },
  ],
  [
    'bugreportservice.create.generic',
    {
      message: 'Erro ao cadastrar o erro do sistema',
    },
  ],
  [
    'bugreportservice.update.generic',
    {
      message: 'Erro ao atualizar o erro do sistema',
    },
  ],
  [
    'bugreportservice.remove.generic',
    {
      message: 'Erro ao deletar o erro do sistema',
    },
  ],
  [
    'bugreportservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // CALENDAR SERVICE
  [
    'calendarservice.setupconfig.missingkey',
    {
      message: 'Serviço de calendário não configurado corretamente',
    },
  ],
  [
    'calendarservice.validation.summary',
    {
      message: 'Favor informar o campo resumo corretamente',
    },
  ],
  [
    'calendarservice.validation.uid',
    {
      message: 'Favor informar o campo uid da data corretamente',
    },
  ],
  [
    'calendarservice.validation.calendarid',
    {
      message: 'Favor informar o campo calendarid da data corretamente',
    },
  ],
  [
    'calendarservice.validation.transportoperadorid',
    {
      message:
        'Favor informar o campo transportoperadorid da data corretamente',
    },
  ],
  [
    'calendarservice.validation.start',
    {
      message: 'Favor informar o campo data de início corretamente',
    },
  ],
  [
    'calendarservice.validation.end',
    {
      message: 'Favor informar o campo data de fim corretamente',
    },
  ],
  [
    'calendarservice.validation.googlecalendarid',
    {
      message: 'Favor informar o campo googlecalendarid da data corretamente',
    },
  ],
  [
    'calendarservice.validation.query',
    {
      message: 'Favor informar o campo query da data corretamente',
    },
  ],
  [
    'calendarservice.validation.eventid',
    {
      message: 'Favor informar o campo eventid da data corretamente',
    },
  ],
  [
    'calendarservice.create.generic',
    {
      message: 'Erro ao cadastrar a data',
    },
  ],
  [
    'calendarservice.update.generic',
    {
      message: 'Erro ao atualizar a data',
    },
  ],
  [
    'calendarservice.remove.generic',
    {
      message: 'Erro ao deletar a data',
    },
  ],
  [
    'calendarservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // CAR SERVICE
  [
    'carservice.validation.carid',
    {
      message: 'Favor informar o campo carid do carro corretamente',
    },
  ],
  [
    'carservice.validation.license',
    {
      message: 'Favor informar o campo placa do carro corretamente',
    },
  ],
  [
    'carservice.validation.prefix',
    {
      message: 'Favor informar o campo prefixo do carro corretamente',
    },
  ],
  [
    'carservice.validation.model',
    {
      message: 'Favor informar o campo modelo do carro corretamente',
    },
  ],
  [
    'carservice.validation.capacity',
    {
      message: 'Favor informar o campo capacidade do carro corretamente',
    },
  ],
  [
    'carservice.validation.accessible',
    {
      message: 'Favor informar o campo acessibilidade do carro corretamente',
    },
  ],
  [
    'carservice.validation.airconditioned',
    {
      message: 'Favor informar o campo climatizado do carro corretamente',
    },
  ],
  [
    'carservice.validation.age',
    {
      message: 'Favor informar o campo idade do carro corretamente',
    },
  ],
  [
    'carservice.validation.picture',
    {
      message: 'Favor insira uma extensão de imagem suportada',
    },
  ],
  [
    'carservice.validation.uid',
    {
      message: 'Favor informar o campo uid do carro corretamente',
    },
  ],
  [
    'carservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do carro corretamente',
    },
  ],
  [
    'carservice.create.generic',
    {
      message: 'Erro ao cadastrar o carro',
    },
  ],
  [
    'carservice.update.generic',
    {
      message: 'Erro ao atualizar o carro',
    },
  ],
  [
    'carservice.remove.generic',
    {
      message: 'Erro ao deletar o carro',
    },
  ],
  [
    'carservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // CHARGE REQUEST SERVICE
  [
    'chargerequestservice.validation.orders',
    {
      message: 'Favor informar o campo pedidos corretamente',
    },
  ],
  [
    'chargerequestservice.validation.userid',
    {
      message: 'Favor informar o campo userid do pedido corretamente',
    },
  ],
  [
    'chargerequestservice.validation.payment',
    {
      message: 'Favor informar o campo pagamento corretamente',
    },
  ],
  [
    'chargerequestservice.validation.context',
    {
      message: 'Erro ao enviar pedidos de recarga',
    },
  ],
  [
    'chargerequestservice.validation.chargerequestid',
    {
      message: 'Favor informar o campo chargerequestid do pedido corretamente',
    },
  ],
  [
    'chargerequestservice.removechargerequest.notfound',
    {
      message: 'Pedido de recarga não encontrado',
    },
  ],
  [
    'chargerequestservice.validation.status',
    {
      message: 'Favor informar o campo status do pedido corretamente',
    },
  ],
  [
    'chargerequestservice.validation.message',
    {
      message: 'Favor informar o campo mensagem corretamente',
    },
  ],
  [
    'chargerequestservice.validation.uid',
    {
      message: 'Favor informar o campo uid do pedido corretamente',
    },
  ],
  [
    'chargerequestservice.removechargerequest.status',
    {
      message: 'Favor informar o campo status corretamente',
    },
  ],
  [
    'chargerequestservice.create.generic',
    {
      message: 'Erro ao cadastrar o pedido',
    },
  ],
  [
    'chargerequestservice.update.generic',
    {
      message: 'Erro ao atualizar o pedido',
    },
  ],
  [
    'chargerequestservice.remove.generic',
    {
      message: 'Erro ao deletar o pedido',
    },
  ],
  [
    'chargerequestservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // COMPANY GROUP SERVICE
  [
    'companygroupservice.validation.name',
    {
      message: 'Favor informar o campo nome do grupo corretamente',
    },
  ],
  [
    'companygroupservice.validation.users',
    {
      message: 'Favor insira os integrantes do grupo corretamente',
    },
  ],
  [
    'companygroupservice.validation.uid',
    {
      message: 'Favor insira os uid do grupo corretamente',
    },
  ],
  [
    'companygroupservice.validation.companygroupid',
    {
      message: 'Favor insira os companygroupid do grupo corretamente',
    },
  ],
  [
    'companygroupservice.create.generic',
    {
      message: 'Erro ao cadastrar o grupo',
    },
  ],
  [
    'companygroupservice.update.generic',
    {
      message: 'Erro ao atualizar o grupo',
    },
  ],
  [
    'companygroupservice.remove.generic',
    {
      message: 'Erro ao deletar o grupo',
    },
  ],
  [
    'companygroupservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // COMPANY SERVICE
  [
    'companyservice.validation.uid',
    {
      message: 'Favor informar o campo uid da empresa corretamente',
    },
  ],
  [
    'companyservice.validation.userslength',
    {
      message: 'Favor informar o campo usuários corretamente',
    },
  ],
  [
    'companyservice.validation.usersbelong',
    {
      message: 'Usuário não percente à empresa',
    },
  ],
  [
    'companyservice.validation.name',
    {
      message: 'Nome da empresa inválido',
    },
  ],
  [
    'companyservice.validation.cnpj',
    {
      message: 'CNPJ da empresa inválido',
    },
  ],
  [
    'companyservice.validation.phone',
    {
      message: 'Telefone da empresa inválido',
    },
  ],
  [
    'companyservice.validation.email',
    {
      message: 'Email da empresa inválido',
    },
  ],
  [
    'companyservice.validation.recaptcha',
    {
      message: 'Favor resolver recaptcha corretamente',
    },
  ],
  [
    'companyservice.validation.companyid',
    {
      message: 'Favor informar o campo companyid da empresa corretamente',
    },
  ],
  [
    'companyservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid da empresa corretamente',
    },
  ],
  [
    'companyservice.removeusers.invalid',
    {
      message: 'Erro ao remover usuários',
    },
  ],
  [
    'companyservice.removeusers.fetch',
    {
      message: 'Usuário não pertence à empresa',
    },
  ],
  [
    'companyservice.paychargerequest.generic',
    {
      message: 'Erro ao gerar pedido de crédito',
    },
  ],
  [
    'companyservice.removechargerequest.generic',
    {
      message: 'Erro ao remover pedido de crédito',
    },
  ],
  [
    'companyservice.addcreditrequest.generic',
    {
      message: 'Erro ao adicionar pedido de crédito',
    },
  ],
  [
    'company.error.cnpj.used',
    {
      message: 'CNPJ já utilizado',
    },
  ],
  [
    'company.error.email.used',
    {
      message: 'Email já utilizado',
    },
  ],

  // DBD SERVICE
  [
    'dbdservice.validation.employeeid',
    {
      message: 'Favor informar o campo employeeid do DBD corretamente',
    },
  ],
  [
    'dbdservice.validation.linesectionid',
    {
      message: 'Favor informar o campo linesectionid do DBD corretamente',
    },
  ],
  [
    'dbdservice.validation.dbdid',
    {
      message: 'Favor informar o campo dbdid do DBD corretamente',
    },
  ],
  [
    'dbdservice.validation.timestamp',
    {
      message: 'Favor informar o campo timestamp do DBD corretamente',
    },
  ],
  [
    'dbdservice.validation.carid',
    {
      message: 'Favor informar o campo carid do DBD corretamente',
    },
  ],
  [
    'dbdservice.validation.serial',
    {
      message: 'Favor informar o campo serial do DBD corretamente',
    },
  ],
  [
    'dbdservice.validation.uid',
    {
      message: 'Favor informar o campo uid do DBD corretamente',
    },
  ],
  [
    'dbdservice.validation.transportoperatorid',
    {
      message: 'Favor informar o campo transportoperatorid do DBD corretamente',
    },
  ],
  [
    'dbdservice.initdbd.inuse',
    {
      message: 'O DBD está em uso',
    },
  ],
  [
    'dbdservice.uninstalldbd.inoperation',
    {
      message: 'O DBD está em operação',
    },
  ],
  [
    'dbdservice.installdbd.alreadyinstalled',
    {
      message: 'O DBD já está instalado',
    },
  ],
  [
    'dbdservice.create.generic',
    {
      message: 'Erro ao cadastrar o DBD',
    },
  ],
  [
    'dbdservice.update.generic',
    {
      message: 'Erro ao atualizar o DBD',
    },
  ],
  [
    'dbdservice.remove.generic',
    {
      message: 'Erro ao deletar o DBD',
    },
  ],
  [
    'dbdservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // RESTRICTION LIST SERVICE
  [
    'restrictionservice.validation.status',
    {
      message: 'Favor informar o campo status do bloqueio corretamente',
    },
  ],
  [
    'restrictionservice.validation.reason',
    {
      message: 'Favor informar o campo motivo do bloqueio corretamente',
    },
  ],
  [
    'restrictionservice.validation.message',
    {
      message: 'Favor informar o campo mensagem do bloqueio corretamente',
    },
  ],
  [
    'restrictionservice.validation.userid',
    {
      message: 'Favor informar o campo userid do bloqueio corretamente',
    },
  ],
  [
    'restrictionservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do bloqueio corretamente',
    },
  ],
  [
    'restrictionservice.validation.dbdid',
    {
      message: 'Favor informar o campo dbdid do bloqueio corretamente',
    },
  ],
  [
    'restrictionservice.listdenylist.notregistered',
    {
      message: 'DBD não registrado',
    },
  ],
  [
    'restrictionservice.create.generic',
    {
      message: 'Erro ao cadastrar o bloqueio',
    },
  ],
  [
    'restrictionservice.update.generic',
    {
      message: 'Erro ao atualizar o bloqueio',
    },
  ],
  [
    'restrictionservice.remove.generic',
    {
      message: 'Erro ao deletar o bloqueio',
    },
  ],
  [
    'restrictionservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // FARE SERVICE
  [
    'fareservice.createfare.validation',
    {
      message: 'Favor informar os campos corretamente',
    },
  ],
  [
    'fareservice.removefare.inuse',
    {
      message: 'A tarifa está em uso',
    },
  ],
  [
    'fareservice.create.generic',
    {
      message: 'Erro ao cadastrar a tarifa',
    },
  ],
  [
    'fareservice.update.generic',
    {
      message: 'Erro ao atualizar a tarifa',
    },
  ],
  [
    'fareservice.remove.generic',
    {
      message: 'Erro ao deletar a tarifa',
    },
  ],
  [
    'fareservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // ITINERARY SERVICE
  [
    'itineraryservice.validation.points',
    {
      message: 'Favor informar os pontos do itinerário corretamente',
    },
  ],
  [
    'itineraryservice.validation.startid',
    {
      message:
        'Favor informar o campo ponto de partida do itinerário corretamente',
    },
  ],
  [
    'itineraryservice.validation.endid',
    {
      message:
        'Favor informar o campo ponto de chegada do itinerário corretamente',
    },
  ],
  [
    'itineraryservice.validation.weekdays',
    {
      message: 'Favor informar os dias da semana do itinerário corretamente',
    },
  ],
  [
    'itineraryservice.validation.hours',
    {
      message: 'Favor informar o(s) horário(s) do itinerário corretamente',
    },
  ],
  [
    'itineraryservice.validation.lineid',
    {
      message: 'Favor informar o campo lineid do itinerário corretamente',
    },
  ],
  [
    'itineraryservice.validation.itineraryid',
    {
      message: 'Favor informar o campo itineraryid do itinerário corretamente',
    },
  ],
  [
    'itineraryservice.create.generic',
    {
      message: 'Erro ao cadastrar o itinerário',
    },
  ],
  [
    'itineraryservice.update.generic',
    {
      message: 'Erro ao atualizar o itinerário',
    },
  ],
  [
    'itineraryservice.remove.generic',
    {
      message: 'Erro ao deletar o itinerário',
    },
  ],
  [
    'itineraryservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // LINE SERVICE
  [
    'lineservice.validation.lineid',
    {
      message: 'Favor informar o campo lineid da linha corretamente',
    },
  ],
  [
    'lineservice.validation.stops',
    {
      message: 'Favor informar os pontos da linha corretamente',
    },
  ],
  [
    'lineservice.validation.uid',
    {
      message: 'Favor informar o campo uid da linha corretamente',
    },
  ],
  [
    'lineservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid da linha corretamente',
    },
  ],
  [
    'lineservice.validation.sections',
    {
      message: 'Favor informar as seções da linha corretamente',
    },
  ],
  [
    'lineservice.validation.sectionids',
    {
      message: 'Favor informar o campo sectionids da linha corretamente',
    },
  ],
  [
    'lineservice.validation.status',
    {
      message: 'Favor informar o campo status da linha corretamente',
    },
  ],
  [
    'lineservice.validation.type',
    {
      message: 'Favor informar o campo tipo da linha corretamente',
    },
  ],
  [
    'lineservice.validation.model',
    {
      message: 'Favor informar o campo modelo da linha corretamente',
    },
  ],
  [
    'lineservice.validation.way',
    {
      message: 'Favor informar o campo sentido da linha corretamente',
    },
  ],
  [
    'lineservice.validation.prefix',
    {
      message: 'Favor informar o campo prefixo da linha corretamente',
    },
  ],
  [
    'lineservice.validation.name',
    {
      message: 'Favor informar o campo nome da linha corretamente',
    },
  ],
  [
    'lineservice.validation.jointlineid',
    {
      message: 'Favor informar o campo jointlineid da linha corretamente',
    },
  ],
  [
    'lineservice.validation.sector',
    {
      message: 'Favor informar o campo setor da linha corretamente',
    },
  ],
  [
    'lineservice.validation.system',
    {
      message: 'Favor informar o campo sistema da linha corretamente',
    },
  ],
  [
    'lineservice.validation.duplicatedsessions',
    {
      message: 'Sessão já existente',
    },
  ],
  [
    'lineservice.create.generic',
    {
      message: 'Erro ao cadastrar a linha',
    },
  ],
  [
    'lineservice.update.generic',
    {
      message: 'Erro ao atualizar a linha',
    },
  ],
  [
    'lineservice.remove.generic',
    {
      message: 'Erro ao deletar a linha',
    },
  ],
  [
    'lineservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // LOT SERVICE
  [
    'lotservice.validation.startdate',
    {
      message: 'Favor informar o campo data de início do lote corretamente',
    },
  ],
  [
    'lotservice.validation.enddate',
    {
      message: 'Favor informar o campo data de fim do lote corretamente',
    },
  ],
  [
    'lotservice.validation.uid',
    {
      message: 'Favor informar o campo uid do lote corretamente',
    },
  ],
  [
    'lotservice.validation.lotid',
    {
      message: 'Favor informar o campo lotid do lote corretamente',
    },
  ],
  [
    'lotservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do lote corretamente',
    },
  ],
  [
    'lotservice.validation.name',
    {
      message: 'Favor informar o campo nome do lote corretamente',
    },
  ],
  [
    'lotservice.validation.value',
    {
      message: 'Favor informar o campo valor corretamente',
    },
  ],
  [
    'lotservice.validation.transaction',
    {
      message: 'Favor informar o campo transação corretamente',
    },
  ],
  [
    'lotservice.validation.operation',
    {
      message: 'Favor informar o campo operação corretamente',
    },
  ],
  [
    'lotservice.validation.transactionvalue',
    {
      message: 'Favor informar o campo valor da transação corretamente',
    },
  ],
  [
    'lotservice.validation.tokenid',
    {
      message: 'Favor informar o campo tokenid do lote corretamente',
    },
  ],
  [
    'lotservice.findvalidlot.valid',
    {
      message: 'Não existe um lote de crédito válido',
    },
  ],
  [
    'lotservice.create.generic',
    {
      message: 'Erro ao cadastrar o lote',
    },
  ],
  [
    'lotservice.update.generic',
    {
      message: 'Erro ao atualizar o lote',
    },
  ],
  [
    'lotservice.remove.generic',
    {
      message: 'Erro ao deletar o lote',
    },
  ],
  [
    'lotservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // OPERATOR SERVICE
  [
    'operatorsevice.validation.name',
    {
      message: 'Favor informar o campo nome da operadora corretamente',
    },
  ],
  [
    'operatorsevice.validation.cnpj',
    {
      message: 'Favor informar o campo cnpj da operadora corretamente',
    },
  ],
  [
    'operatorsevice.validation.recaptcha',
    {
      message: 'Favor resolver recaptcha corretamente',
    },
  ],
  [
    'operatorsevice.validation.supervisors',
    {
      message: 'Favor informar os supervisores da operadora corretamente',
    },
  ],
  [
    'operatorservice.create.generic',
    {
      message: 'Erro ao cadastrar a operadora',
    },
  ],
  [
    'operatorservice.update.generic',
    {
      message: 'Erro ao atualizar a operadora',
    },
  ],
  [
    'operatorservice.remove.generic',
    {
      message: 'Erro ao deletar a operadora',
    },
  ],
  [
    'operatorservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // PAYMENT REQUEST SERVICE
  [
    'paymentrequestservice.validation.value',
    {
      message: 'Favor informar o campo valor do pagamento corretamente',
    },
  ],
  [
    'paymentrequestservice.validation.tax',
    {
      message: 'Favor informar o campo taxa corretamente',
    },
  ],
  [
    'paymentrequestservice.validation.type',
    {
      message: 'Favor informar o campo tipo do pagamento corretamente',
    },
  ],
  [
    'paymentrequestservice.validation.data',
    {
      message: 'Favor informar o campo data do pagamento corretamente',
    },
  ],
  [
    'paymentrequestservice.validation.paymentrequestid',
    {
      message:
        'Favor informar o campo paymentrequestid do pagamento corretamente',
    },
  ],
  [
    'paymentrequestservice.validation.status',
    {
      message: 'Favor informar o campo status do pagamento corretamente',
    },
  ],
  [
    'paymentrequestservice.validation.message',
    {
      message: 'Favor informar o campo mensagem corretamente',
    },
  ],
  [
    'paymentrequestservice.create.generic',
    {
      message: 'Erro ao cadastrar o pagamento',
    },
  ],
  [
    'paymentrequestservice.update.generic',
    {
      message: 'Erro ao atualizar o pagamento',
    },
  ],
  [
    'paymentrequestservice.remove.generic',
    {
      message: 'Erro ao deletar o pagamento',
    },
  ],
  [
    'paymentrequestservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // PROFILE SERVICE
  [
    'profileservice.validation.profileid',
    {
      message: 'Favor informar o campo profileid do perfil corretamente',
    },
  ],
  [
    'profileservice.validation.order',
    {
      message: 'Favor informar o campo ordem do perfil corretamente',
    },
  ],
  [
    'profileservice.validation.profiles',
    {
      message: 'Favor informar o campo perfil corretamente',
    },
  ],
  [
    'profileservice.validation.uid',
    {
      message: 'Favor informar o campo uid do perfil corretamente',
    },
  ],
  [
    'profileservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do perfil corretamente',
    },
  ],
  [
    'profileservice.validation.name',
    {
      message: 'Favor informar o campo nome do perfil corretamente',
    },
  ],
  [
    'profileservice.validation.data',
    {
      message: 'Favor informar o campo data do perfil corretamente',
    },
  ],
  [
    'profileservice.validation.expires',
    {
      message: 'Favor informar o campo expira do perfil corretamente',
    },
  ],
  [
    'profileservice.removeprofile.used',
    {
      message: 'Perfil em uso',
    },
  ],
  [
    'profileservice.createprofile.duplicatedorder',
    {
      message: 'Posição já utilizada',
    },
  ],
  [
    'profileservice.create.generic',
    {
      message: 'Erro ao cadastrar o perfil',
    },
  ],
  [
    'profileservice.update.generic',
    {
      message: 'Erro ao atualizar o perfil',
    },
  ],
  [
    'profileservice.remove.generic',
    {
      message: 'Erro ao deletar o perfil',
    },
  ],
  [
    'profileservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],
  [
    CONST_PROFILE.CANNOT_BE_UPDATED,
    {
      message: 'Esse perfil não pode ser editado',
    },
  ],

  // SCHOOL SERVICE
  [
    'schoolservice.validation.name',
    {
      message: 'Favor informar o campo nome da instituição corretamente',
    },
  ],
  [
    'schoolservice.validation.phone',
    {
      message: 'Favor informar o campo telefone da instituição corretamente',
    },
  ],
  [
    'schoolservice.validation.email',
    {
      message: 'Favor informar o campo email da instituição corretamente',
    },
  ],
  [
    'schoolservice.validation.mec',
    {
      message: 'Favor informar o campo mec da instituição corretamente',
    },
  ],
  [
    'schoolservice.validation.status',
    {
      message: 'Favor informar o campo status da instituição corretamente',
    },
  ],
  [
    'schoolservice.validation.schoolid',
    {
      message: 'Favor informar o campo schoolid da instituição corretamente',
    },
  ],
  [
    'schoolservice.validation.userids',
    {
      message: 'Favor informar o campo userids da instituição corretamente',
    },
  ],
  [
    'schoolservice.checkusers.length',
    {
      message: 'Lista de usuários inválida',
    },
  ],
  [
    'schoolservice.checkusers.invaliddata',
    {
      message: 'Dados de usuários inválidos',
    },
  ],
  [
    'schoolservice.checkschoolstatus.status',
    {
      message: 'Favor informar o campo status corretamente',
    },
  ],
  [
    'schoolservice.removeusers.invaliddata',
    {
      message: 'Dados de usuários inválidos na remoção',
    },
  ],
  [
    'schoolservice.removeusers.invalidusers',
    {
      message: 'Lista de usuários inválidos na remoção',
    },
  ],
  [
    'schoolservice.create.generic',
    {
      message: 'Erro ao cadastrar a instituição',
    },
  ],
  [
    'schoolservice.update.generic',
    {
      message: 'Erro ao atualizar a instituição',
    },
  ],
  [
    'schoolservice.remove.generic',
    {
      message: 'Erro ao deletar a instituição',
    },
  ],
  [
    'schoolservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // SECTION SERVICE
  [
    'sectionservice.validation.name',
    {
      message: 'Favor informar o campo nome da seção corretamente',
    },
  ],
  [
    'sectionservice.validation.startid',
    {
      message: 'Favor informar o campo parada inicial da seção corretamente',
    },
  ],
  [
    'sectionservice.validation.endid',
    {
      message: 'Favor informar o campo parada final da seção corretamente',
    },
  ],
  [
    'sectionservice.validation.uid',
    {
      message: 'Favor informar o campo uid da seção corretamente',
    },
  ],
  [
    'sectionservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid da seção corretamente',
    },
  ],
  [
    'sectionservice.validation.sectionid',
    {
      message: 'Favor informar o campo sectionid da seção corretamente',
    },
  ],
  [
    'sectionservice.checksection.inuse',
    {
      message: 'Trecho está em uso por alguma linha',
    },
  ],
  [
    'sectionservice.create.generic',
    {
      message: 'Erro ao cadastrar a seção',
    },
  ],
  [
    'sectionservice.update.generic',
    {
      message: 'Erro ao atualizar a seção',
    },
  ],
  [
    'sectionservice.remove.generic',
    {
      message: 'Erro ao remover a seção',
    },
  ],
  [
    'sectionservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // STOP SERVICE
  [
    'stopservice.validation.name',
    {
      message: 'Favor informar o campo nome do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.startlat',
    {
      message: 'Favor informar o campo latitude inicial do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.startlong',
    {
      message: 'Favor informar o campo longitude inicial do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.endlat',
    {
      message: 'Favor informar o campo latitude final do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.endlong',
    {
      message: 'Favor informar o campo longitude final do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.covered',
    {
      message: 'Favor informar o campo coberto do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.busbay',
    {
      message: 'Favor informar o campo baia do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.specialbusstop',
    {
      message: 'Favor informar se o ponto deve ser destacado no mapa',
    },
  ],
  [
    'stopservice.validation.address',
    {
      message: 'Favor informar o campo endereço do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.radius',
    {
      message: 'Favor informar o campo raio do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.stops',
    {
      message: 'Favor informar o campo paradas corretamente',
    },
  ],
  [
    'stopservice.validation.uid',
    {
      message: 'Favor informar o campo uid do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do ponto corretamente',
    },
  ],
  [
    'stopservice.validation.stopid',
    {
      message: 'Favor informar o campo stopid do ponto corretamente',
    },
  ],
  [
    'stopservice.checkstop.inuse',
    {
      message: 'Parada em uso por alguma linha',
    },
  ],
  [
    'stopservice.create.generic',
    {
      message: 'Erro ao cadastrar o ponto',
    },
  ],
  [
    'stopservice.update.generic',
    {
      message: 'Erro ao atualizar o ponto',
    },
  ],
  [
    'stopservice.remove.generic',
    {
      message: 'Erro ao deletar o ponto',
    },
  ],
  [
    'stopservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // SUPERVISOR GROUP SERVICE
  [
    'supervisorgroupservice.validation.name',
    {
      message: 'Favor informar o campo nome do grupo corretamente',
    },
  ],
  [
    'supervisorgroupservice.validation.users',
    {
      message: 'Favor informar os integrantes do grupo corretamente',
    },
  ],
  [
    'supervisorgroupservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do grupo corretamente',
    },
  ],
  [
    'supervisorgroupservice.validation.groupid',
    {
      message: 'Favor informar o campo groupid do grupo corretamente',
    },
  ],
  [
    'supervisorgroupservice.validation.uid',
    {
      message: 'Favor informar o campo uid do grupo corretamente',
    },
  ],
  [
    'supervisorgroup.create.generic',
    {
      message: 'Erro ao cadastrar o grupo',
    },
  ],
  [
    'supervisorgroup.update.generic',
    {
      message: 'Erro ao atualizar o grupo',
    },
  ],
  [
    'supervisorgroup.remove.generic',
    {
      message: 'Erro ao deletar o grupo',
    },
  ],
  [
    'supervisorgroup.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // SUPERVISOR SERVICE
  [
    'supervisorservice.validation.userid',
    {
      message: 'Favor informar o campo userid do supervisor corretamente',
    },
  ],
  [
    'supervisorservice.validation.supervisors',
    {
      message: 'Favor informar o campo supervisor corretamente',
    },
  ],
  [
    'supervisor.validation.name',
    {
      message: 'Favor informar o campo nome do supervisor corretamente',
    },
  ],
  [
    'supervisor.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do supervisor corretamente',
    },
  ],
  [
    'supervisor.validation.groupid',
    {
      message: 'Favor informar o campo groupid do supervisor corretamente',
    },
  ],
  [
    'supervisor.validation.uid',
    {
      message: 'Favor informar o campo uid do supervisor corretamente',
    },
  ],
  [
    'supervisorservice.validation.generic',
    {
      message: 'Favor informar os campos corretamente',
    },
  ],
  [
    'supervisorservice.updatesupervisor.error',
    {
      message: 'Favor informar os campo pedidos corretamente',
    },
  ],
  [
    'supervisorservice.create.generic',
    {
      message: 'Erro ao cadastrar o supervisor',
    },
  ],
  [
    'supervisorservice.update.generic',
    {
      message: 'Erro ao atualizar o supervisor',
    },
  ],
  [
    'supervisorservice.remove.generic',
    {
      message: 'Erro ao deletar o supervisor',
    },
  ],
  [
    'supervisorservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // TOKEN SERVICE
  [
    'tokenservice.createtoken.userblocked',
    {
      message: 'Usuário está bloqueado',
    },
  ],
  [
    'tokenservice.createtokenentry.alreadyvalidated',
    {
      message: 'Token já validado',
    },
  ],
  [
    'tokenservice.createtokenentry.notfound',
    {
      message: 'Token não encontrado',
    },
  ],
  [
    'tokenservice.revalidatedtoken.userblocked',
    {
      message: 'Usuário bloqueado',
    },
  ],
  [
    'tokenservice.revalidatedtoken.used',
    {
      message: 'Token já revalidado',
    },
  ],
  [
    'tokenservice.revalidatedtoken.notexpired',
    {
      message: 'Token ainda não expirou',
    },
  ],
  [
    'tokenservice.create.generic',
    {
      message: 'Erro ao cadastrar o token',
    },
  ],
  [
    'tokenservice.update.generic',
    {
      message: 'Erro ao atualizar o token',
    },
  ],
  [
    'tokenservice.remove.generic',
    {
      message: 'Erro ao deletar o token',
    },
  ],
  [
    'tokenservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // TRANSPORT CARD SERVICE
  [
    'transportcardservice.validation.uid',
    {
      message: 'Favor informar o campo uid do cartão corretamente',
    },
  ],
  [
    'transportcardservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do cartão corretamente',
    },
  ],
  [
    'transportcardservice.validation.code',
    {
      message: 'Favor informar o campo código do cartão corretamente',
    },
  ],
  [
    'transportcardservice.validation.transportcards',
    {
      message: 'Favor informar o campo cartões de transporte corretamente',
    },
  ],
  [
    'transportcardservice.validation.type',
    {
      message: 'Favor informar o campo tipo do cartão corretamente',
    },
  ],
  [
    'transportcardservice.validation.status',
    {
      message: 'Favor informar o campo status do cartão corretamente',
    },
  ],
  [
    'transportcardservice.validation.number',
    {
      message: 'Favor informar o campo número do cartão corretamente',
    },
  ],
  [
    'transportcardservice.validation.lot',
    {
      message: 'Favor informar o campo lote do cartão corretamente',
    },
  ],
  [
    'transportcardservice.validation.transportcardid',
    {
      message: 'Favor informar o campo transportcardid do cartão corretamente',
    },
  ],
  [
    'transportcardservice.validation.userid',
    {
      message: 'Favor informar o campo userid do cartão corretamente',
    },
  ],
  [
    'transportcardservice.checkusercards.max',
    {
      message: 'Limite máximo de cartão por usuário atingido',
    },
  ],
  [
    'transportcardservice.createcardentry.notfound',
    {
      message: 'Cartão de transporte não encontrado',
    },
  ],
  [
    'transportcardservice.createcardentry.alreadyvalidated',
    {
      message: 'Cartão de transporte já validado',
    },
  ],
  [
    'transportcardservice.requesttransportcard.nocards',
    {
      message: 'Não existe cartão de transporte disponível',
    },
  ],
  [
    'transportcardservice.create.generic',
    {
      message: 'Erro ao cadastrar o cartão',
    },
  ],
  [
    'transportcardservice.update.generic',
    {
      message: 'Erro ao atualizar o cartão',
    },
  ],
  [
    'transportcardservice.remove.generic',
    {
      message: 'Erro ao deletar o cartão',
    },
  ],
  [
    'transportcardservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // TRANSPORT EMPLOYEE SERVICE
  [
    'transportemployeeservice.validation.name',
    {
      message: 'Favor informar o campo nome do funcionário corretamente',
    },
  ],
  [
    'transportemployeeservice.validation.transportemployeeid',
    {
      message:
        'Favor informar o campo transportemployeeid do funcionário corretamente',
    },
  ],
  [
    'transportemployeeservice.validation.uid',
    {
      message: 'Favor informar o campo uid do funcionário corretamente',
    },
  ],
  [
    'transportemployeeservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do funcionário corretamente',
    },
  ],
  [
    'transportemployeeservice.validation.phone',
    {
      message: 'Favor informar o campo telefone do funcionário corretamente',
    },
  ],
  [
    'transportemployee.error.document.invalid',
    {
      message: 'Favor informar o campo documento do funcionário corretamente',
    },
  ],
  [
    'transportemployee.error.document.used',
    {
      message: 'O documento já está em uso',
    },
  ],
  [
    'transportemployeeservice.create.generic',
    {
      message: 'Erro ao cadastrar o funcionário',
    },
  ],
  [
    'transportemployeeservice.update.generic',
    {
      message: 'Erro ao atualizar o funcionário',
    },
  ],
  [
    'transportemployeeservice.remove.generic',
    {
      message: 'Erro ao deletar o funcionário',
    },
  ],
  [
    'transportemployeeservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],
  [
    'transportemployeeservice.addpayment.nopendingtrip',
    {
      message: 'Não há pendências para o motorista',
    },
  ],
  [
    'transportemployeeservice.addpayment.paymorethanneeded',
    {
      message: 'O valor a dar baixa é maior que o devido',
    },
  ],

  // USER PROFILE SERVICE
  [
    'userprofileservice.validation.userid',
    {
      message: 'Favor informar o campo usuário corretamente',
    },
  ],
  [
    'userprofileservice.validation.profileid',
    {
      message: 'Favor informar o campo perfil corretamente',
    },
  ],
  [
    'userprofileservice.validation.type',
    {
      message: 'Favor informar o campo tipo corretamente',
    },
  ],
  [
    'userprofileservice.validation.userprofilerequestid',
    {
      message: 'Favor informar o campo pedido corretamente',
    },
  ],
  [
    'userprofileservice.validation.message',
    {
      message: 'Favor informar o campo mensagem corretamente',
    },
  ],
  [
    'userprofileservice.validation.status',
    {
      message: 'Favor informar o campo status corretamente',
    },
  ],
  [
    'userprofileservice.create.generic',
    {
      message: 'Erro ao criar pedido de perfil',
    },
  ],
  [
    'userprofileservice.update.generic',
    {
      message: 'Erro ao atualizar pedido de perfil',
    },
  ],
  [
    'userprofileservice.remove.generic',
    {
      message: 'Erro ao remover pedido de perfil',
    },
  ],
  [
    'userprofileservice.error.generic',
    {
      message: 'Erro ao executar operação de pedido de perfil',
    },
  ],

  // WALLET CHARGE SERVICE
  [
    'walletchargeservice.validation.id',
    {
      message: 'Favor informar o campo id corretamente',
    },
  ],
  [
    'walletchargeservice.validation.userid',
    {
      message: 'Favor informar o campo usuário corretamente',
    },
  ],
  [
    'walletchargeservice.validation.value',
    {
      message: 'Favor informar o campo valor corretamente',
    },
  ],
  [
    'walletchargeservice.checkuserscore.value',
    {
      message: 'Usuário não tem saldo',
    },
  ],
  [
    'walletchargeservice.create.generic',
    {
      message: 'Erro ao criar pedido de crédito',
    },
  ],
  [
    'walletchargeservice.update.generic',
    {
      message: 'Erro ao atualizar pedido de crédito',
    },
  ],
  [
    'walletchargeservice.remove.generic',
    {
      message: 'Erro ao remover pedido de crédito',
    },
  ],
  [
    'walletchargeservice.error.generic',
    {
      message: 'Erro ao executar operação',
    },
  ],

  // WALLET HISTORY SERVICE
  [
    'wallethistoryservice.validation.operation',
    {
      message: 'Favor informar o campo operação corretamente',
    },
  ],
  [
    'wallethistoryservice.validation.transactionvalue',
    {
      message: 'Favor informar o campo valor da operação corretamente',
    },
  ],
  [
    'wallethistoryservice.validation.walletchargeid',
    {
      message: 'Favor informar o campo pedido corretamente',
    },
  ],
  [
    'wallethistoryservice.validation.userid',
    {
      message: 'Favor informar o campo usuário corretamente',
    },
  ],
  [
    'wallethistoryservice.validation.transaction',
    {
      message: 'Favor informar o campo transação corretamente',
    },
  ],
  [
    'wallethistoryservice.getbalance.invalidoperation',
    {
      message: 'Operação inválida',
    },
  ],
  [
    'wallethistoryservice.create.generic',
    {
      message: 'Erro ao criar histórico de pedido',
    },
  ],
  [
    'wallethistoryservice.update.generic',
    {
      message: 'Erro ao atualizar histórico de pedido',
    },
  ],
  [
    'wallethistoryservice.remove.generic',
    {
      message: 'Erro ao remover histórico de pedido',
    },
  ],
  [
    'wallethistoryservice.error.generic',
    {
      message: 'Erro ao executar operação',
    },
  ],

  // REPORT SERVICE
  [
    'reportservice.validation.type',
    {
      message: 'Favor informar o campo tipo do relatório corretamente',
    },
  ],
  [
    'reportservice.validation.uid',
    {
      message: 'Favor informar o campo uid do relatório corretamente',
    },
  ],
  [
    'reportservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do relatório corretamente',
    },
  ],
  [
    'reportservice.validation.startdate',
    {
      message:
        'Favor informar o campo data de início do relatório corretamente',
    },
  ],
  [
    'reportservice.validation.enddate',
    {
      message: 'Favor informar o campo data de fim do relatório corretamente',
    },
  ],
  [
    'reportservice.validation.profileid',
    {
      message: 'Favor informar os perfis do relatório corretamente',
    },
  ],
  [
    'reportservice.validation.paymenttype',
    {
      message: 'Favor informar os tipos de pagamento do relatório corretamente',
    },
  ],
  [
    'reportservice.validation.lineid',
    {
      message: 'Favor informar as linhas do relatório corretamente',
    },
  ],

  // BENEFIT SERVICE
  [
    'benefitservice.validation.name',
    {
      message: 'Favor informar o campo nome do benefício corretamente',
    },
  ],
  [
    'benefitservice.validation.data',
    {
      message: 'Favor informar o campo data do benefício corretamente',
    },
  ],
  [
    'benefitservice.validation.uid',
    {
      message: 'Favor informar o campo uid do benefício corretamente',
    },
  ],
  [
    'benefitservice.validation.transportoperatorid',
    {
      message:
        'Favor informar o campo transportoperatorid do benefício corretamente',
    },
  ],
  [
    'benefitservice.validation.status',
    {
      message: 'Favor informar o campo status do benefício corretamente',
    },
  ],
  [
    'benefitservice.validation.benefitid',
    {
      message: 'Favor informar o campo benefitid do benefício corretamente',
    },
  ],
  [
    'benefitservice.validation.lineids',
    {
      message: 'Favor informar as linhas do benefício corretamente',
    },
  ],
  [
    'benefitservice.validation.userid',
    {
      message: 'Favor informar o campo userid do benefício corretamente',
    },
  ],
  [
    'benefitservice.validation.entryid',
    {
      message: 'Favor informar o campo entrada corretamente',
    },
  ],
  [
    'benefitservice.validation.transaction',
    {
      message: 'Favor informar o campo transação corretamente',
    },
  ],
  [
    'benefitservice.create.generic',
    {
      message: 'Erro ao cadastrar o benefício',
    },
  ],
  [
    'benefitservice.update.generic',
    {
      message: 'Erro ao atualizar o benefício',
    },
  ],
  [
    'benefitservice.remove.generic',
    {
      message: 'Erro ao deletar o benefício',
    },
  ],
  [
    'benefitservice.error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // SELLING TERMINAL SERVICE
  [
    'sellingterminal.validation.sellingterminalid',
    {
      message: 'Favor informar todos os campos corretamente',
    },
  ],
  [
    'sellingterminal.validation.amount',
    {
      message: 'Favor informar o campo valor corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.transportoperatorid',
    {
      message: 'Favor informar todos os campos corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.billingperiod',
    {
      message: 'Favor informar o campo período de faturamento corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.fee',
    {
      message: 'Favor informar o campo comissão corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.status',
    {
      message: 'Favor informar o campo status corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.type',
    {
      message: 'Favor informar o campo tipo corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.allowedAmount',
    {
      message: 'Favor informar o campo quantidade permitida corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.name',
    {
      message: 'Favor informar o campo nome corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.address',
    {
      message: 'Favor informar o campo endereço',
    },
  ],
  [
    'sellingterminalservice.validation.document',
    {
      message: ' Favor informar o campo documento corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.email',
    {
      message: 'Favor informar o campo email corretamente',
    },
  ],
  [
    'sellingterminalservice.validation.phone',
    {
      message: 'Favor informar o campo telefone',
    },
  ],

  // SELLING POINT SERVICE
  [
    'sellingpointservice.validation.linesectionid',
    {
      message: 'Favor informar o campo linha corretamente',
    },
  ],
  [
    'sellingpointservice.validation.transactionpassword',
    {
      message: 'Senha de transação inválida',
    },
  ],
  [
    'sellingpointservice.validation.amount',
    {
      message: 'Favor informar o campo valor corretamente',
    },
  ],
  [
    'sellingpointservice.validation.document',
    {
      message: 'Favor informar o campo documento corretamente',
    },
  ],
  [
    'sellingpointservice.validation.sellingterminalid',
    {
      message: 'Favor informar o ID da Rede de venda corretamente',
    },
  ],
  [
    'sellingpointservice.validation.status',
    {
      message: 'Favor informar o campo status corretamente',
    },
  ],
  [
    'sellingpointservice.validation.type',
    {
      message: 'Favor informar o campo tipo corretamente',
    },
  ],
  [
    'sellingpointservice.validation.allowedAmount',
    {
      message: 'Favor informar o campo limite de compra corretamente',
    },
  ],
  [
    'sellingpointservice.validation.name',
    {
      message: 'Favor informar o campo nome corretamente',
    },
  ],
  [
    'sellingpointservice.validation.email',
    {
      message: 'Favor informar o campo email corretamente',
    },
  ],
  [
    'sellingpointservice.validation.phone',
    {
      message: 'Favor informar o campo telefone corretamente',
    },
  ],
  [
    'sellingpoint.validation.sellingpointid',
    {
      message: 'Favor informar o campo ID do ponto de venda corretamente',
    },
  ],
  [
    'sellingpointservice.validation.newpassword',
    {
      message: 'Nova senha exigida',
    },
  ],
  [
    'sellingpointservice.createpurchasetranscation.notfound',
    {
      message: 'Ponto de venda não encontrado',
    },
  ],
  [
    'sellingpointservice.createpurchasetranscation.blocked',
    {
      message: 'Ponto de venda bloqueado',
    },
  ],
  [
    'sellingpointservice.createpurchasetranscation.terminalnotfound',
    {
      message: 'Rede de venda não encontrada',
    },
  ],
  [
    'sellingpointservice.createpurchasetranscation.terminalblocked',
    {
      message: 'Rede de venda bloqueada',
    },
  ],
  [
    'sellingpointservice.createpurchasetranscation.linesectionnotfound',
    {
      message: 'Linha não encontrada',
    },
  ],
  [
    'sellingpointservice.createpurchasetranscation.usernotfound',
    {
      message: 'Usuário não encontrado',
    },
  ],
  [
    'sellingpointservice.checkallowedamount.point',
    {
      message: 'Ponto de venda não possui limite de venda disponível',
    },
  ],
  [
    'sellingpointservice.checkallowedamount.terminal',
    {
      message: 'Rede de venda não possui limite de venda disponível',
    },
  ],

  // USER IP SERVICE
  [
    'useripservice.checkip.block',
    {
      message: 'Acesso negado por IP',
    },
  ],
  [
    'useripservice.validation.name',
    {
      message: 'Favor informar o campo nome',
    },
  ],
  [
    'useripservice.validation.start',
    {
      message: 'Favor informar o campo endereço inicial',
    },
  ],
  [
    'useripservice.validation.end',
    {
      message: 'Favor informar o campo endereço final',
    },
  ],
  [
    'useripservice.validation.userids',
    {
      message: 'Favor informar usuários para a restrição',
    },
  ],
  [
    'useripservice.validation.type',
    {
      message: 'Favor informar o campo tipo do bloqueio de IP',
    },
  ],
  [
    'useripservice.validation.owner',
    {
      message: 'Favor informar o campo identificador',
    },
  ],
  [
    'useripservice.validation.resourceipid',
    {
      message: 'Favor informar o campo ID do endereço IP',
    },
  ],
  [
    'userip.error.startip.invalid',
    {
      message: 'Endereço de início inválido',
    },
  ],
  [
    'userip.error.endip.invalid',
    {
      message: 'Endereço de final inválido',
    },
  ],
  [
    'useripservice.checkip.block',
    {
      message: 'O IP não está liberado',
    },
  ],

  // GENERIC
  [
    'error.generic',
    {
      message: 'Erro ao executar sua operação',
    },
  ],

  // AUTH
  [
    'authmiddleware.handlelistauth.notallowed',
    {
      message: 'Operação não permitida',
    },
  ],
  [
    'mainmiddleware.featureToggle.disabled',
    {
      message: 'Função desabilitada neste ambiente',
    },
  ],
  [
    'auth/email-already-exists',
    {
      message: 'O email já está em uso',
    },
  ],
  [
    'auth/phone-number-already-exists',
    {
      message: 'O telefone já está em uso',
    },
  ],
  [
    CONST_AUTH.FIREBASE_FORBIDDEN,
    {
      message: 'Sessão expirada, favor logar novamente',
    },
  ],

  // EMV PENDING PUBLIC (pagamento de pendências pelo passageiro, sem login)
  // Mensagens para o usuário final: sem jargão de supervisor.
  [
    'emvpendingpublicservice.validation.cardnumber',
    {
      message: 'Número do cartão inválido. Confira os dígitos e tente novamente.',
    },
  ],
  [
    'emvpendingpublicservice.validation.expirationdate',
    {
      message: 'Data de validade inválida. Informe no formato MM/AA.',
    },
  ],
  [
    'emvpendingpublicservice.validation.transportoperatorid',
    {
      message: 'Link inválido. Solicite um novo link à operadora.',
    },
  ],
  [
    'emvpendingpublicservice.validation.ids',
    {
      message: 'Selecione ao menos uma transação para pagar.',
    },
  ],
  [
    'emvpendingpublicservice.validation.paymentid',
    {
      message: 'Pagamento não identificado. Consulte as pendências novamente.',
    },
  ],
  [
    'emvpendingpublicservice.validation.recaptcha',
    {
      message:
        'Verificação de segurança inválida. Marque "Não sou um robô" novamente.',
    },
  ],
  [
    'emvpendingpaymentservice.generatepixfortransactions.pendingrequest',
    {
      message:
        'Já existe um PIX aguardando pagamento que inclui uma das transações selecionadas. Use o PIX pendente ou aguarde ele expirar para gerar outro.',
    },
  ],
  [
    'emvpendingpublicservice.throttle.exceeded',
    {
      message: 'Muitas tentativas. Aguarde alguns minutos e tente novamente.',
    },
  ],
  [
    'operatorservice.validaterecaptcha.error',
    {
      message:
        'Não foi possível validar a verificação de segurança. Marque "Não sou um robô" novamente.',
    },
  ],
]);
const LIST_ERROR_CODES = {
  'appuserservice.listappuser.notfound': true,
};

/*
 * Códigos 404 da página pública de pendências.
 * Ficam FORA do ERROR_CODE_MAP de propósito: o interceptor de
 * services/apiDigitalTicket/base.ts redireciona qualquer resposta 404 cujo
 * internalCode esteja no ERROR_CODE_MAP para a página "funcionalidade
 * desativada" do BDOS, o que tiraria o passageiro da página pública.
 */
const PUBLIC_PENDENCIES_404_ERROR_CODE_MAP = new Map([
  [
    'emvpendingpublicservice.operator.notfound',
    {
      message: 'Operadora não encontrada. Confira o link recebido.',
    },
  ],
  [
    'emvpendingpaymentservice.getpaymentstatus.notfound',
    {
      message: 'Pagamento não encontrado. Consulte as pendências novamente.',
    },
  ],
  [
    'emvpendingpaymentservice.generatepixfortransactions.notfound',
    {
      message:
        'Uma ou mais transações não foram encontradas ou já foram pagas. Consulte as pendências novamente.',
    },
  ],
]);

export {
  ERROR_CODE_MAP,
  LIST_ERROR_CODES,
  PUBLIC_PENDENCIES_404_ERROR_CODE_MAP,
};
